import { call, put } from "redux-saga/effects";
import { setFilteredProducts } from "../actions";
import axios from "axios";
import Cookies from 'js-cookie'



const requestGetFilteredProducts = (filters, skip, limit) => {
    const { title, categoryId, subCategoryId, location, distance, marketFilter, sort, lng, lat } = filters;
    return axios.request({
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Cookies.get('token')
        },
        url: `${process.env.REACT_APP_SERVER_URL}/v1/products/get-filtered-products?title=${title}&categoryId=${categoryId}&subCategoryId=${subCategoryId}&city=${location}&distance=${distance}&marketFilter=${marketFilter}&sort=${sort}&skip=${skip}&limit=${limit}&lat=${lat}&lng=${lng}`
    })
}

export function* handleGetFilteredProducts(action) {
    const { filters, skip, pageNumber, limit } = action.payload;
    const response = yield call(requestGetFilteredProducts, filters, skip, limit);
    console.log("axios response for filtered products: ", response);
    yield put(setFilteredProducts(response.data, filters, pageNumber));
}